export default __webpack_public_path__ + "static/media/portfolio-144.95ed9869.jpg";